import React, { Component } from 'react'
import { Field } from 'redux-form'
import Selector from './selector'

class ExternalNewsInput extends Component {
  render() {
    if (this.props.source) {
      return <Field slug={this.props.slug} label={this.props.label} component={Selector} name={this.props.source} />
    } else {
      return <Selector {...this.props} />
    }
  }
}

export default ExternalNewsInput
